import { defineMessages } from "react-intl";

const SECRET_QUESTION_READONLY = "secret-question-readonly";

const secretQuestionReadonlyMessages = defineMessages({
  secretQuestion: {
    id: `${SECRET_QUESTION_READONLY}.secret-question`,
    defaultMessage: "Secret question"
  },
  changeSecretQuestion: {
    id: `${SECRET_QUESTION_READONLY}.change-secret-question`,
    defaultMessage: "Change secret question?",
    description: "Text displayed for link to changes secret question page"
  }
});

export default secretQuestionReadonlyMessages;
